var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#262949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1426 8.37491C21.6259 8.86788 21.6181 9.65929 21.1251 10.1426L12.1213 18.9698L7.40797 14.6738C6.89775 14.2088 6.86113 13.4182 7.32617 12.908C7.79122 12.3977 8.58183 12.3611 9.09205 12.8262L12.0587 15.5302L19.3749 8.35741C19.8679 7.87411 20.6593 7.88195 21.1426 8.37491Z",
    fill: "#F5F6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCheck);
export default __webpack_public_path__ + "static/media/icn-check.adb4aca924aff0596050b2a2793e385c.svg";
export { ForwardRef as ReactComponent };